import { Component, Inject, Injector, OnInit } from '@angular/core';
import {
  AUTHENTICATION_SERVICE,
  AuthenticationService,
} from '../../../../core/public-api';
import { PageBaseComponent } from '../../bases/page-base.component';

@Component({
  templateUrl: './no-permission.component.html',
  styleUrls: ['./no-permission.component.scss'],
})
export class NoPermissionComponent extends PageBaseComponent implements OnInit {
  constructor(
    injector: Injector,
    @Inject(AUTHENTICATION_SERVICE)
    private _authenticationService: AuthenticationService
  ) {
    super(injector);
  }
  ngOnInit(): void {}

  initDefaultData(): void {}

  login(): void {
    this._authenticationService.logout();
    window.location.href = '/';
  }
}
